// extracted by mini-css-extract-plugin
export default {"wrapper":"menu_wrapper__y2LSw","btn":"menu_btn__got51"};